module.exports = __webpack_public_path__ + "static/img/ununtb.31bd009.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UniLogo/ununtb.jpeg
// module id = xLFf
// module chunks = 15